<div fxLayout="column" fxLayoutGap="10px">
  <div>
    <span class="title">Point constraint</span>
  </div>
  <form id="myForm" [formGroup]="form" class="vertical-form" fxLayout="row" fxLayoutGap="10px">
    <mat-form-field fxFlex>
      <mat-label>Daily points limit per User</mat-label>
      <input type="number" matInput min="1" placeholder="" formControlName="userDailyPoints"
        autocomplete="off">
      @if (form.controls.userDailyPoints.dirty && form.controls.userDailyPoints.errors?.min) {
        <mat-error>Accept positive integer over 1 only</mat-error>
      }
    </mat-form-field>

    <mat-form-field fxFlex>
      <mat-label>Total points limit per User</mat-label>
      <input type="number" matInput min="1" placeholder="" formControlName="userTotalPoints"
        autocomplete="off">
      @if (form.controls.userTotalPoints.dirty && form.controls.userTotalPoints.errors?.min) {
        <mat-error>Accept positive integer over 1 only</mat-error>
      }
    </mat-form-field>

    <mat-form-field fxFlex>
      <mat-label>Daily points limit per Opener</mat-label>
      <input type="number" matInput min="1" placeholder="" formControlName="openerDailyPoints"
        autocomplete="off">
      @if (form.controls.openerDailyPoints.dirty && form.controls.openerDailyPoints.errors?.min) {
        <mat-error>Accept positive integer over 1 only</mat-error>
      }
    </mat-form-field>

    <mat-form-field fxFlex>
      <mat-label>Total points limit per Opener</mat-label>
      <input type="number" matInput min="1" placeholder="" formControlName="openerTotalPoints"
        autocomplete="off">
      @if (form.controls.openerTotalPoints.dirty && form.controls.openerTotalPoints.errors?.min) {
        <mat-error>Accept positive integer over 1 only</mat-error>
      }
    </mat-form-field>
  </form>
</div>